<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-05 11:55:52
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div>
		<span :class="['bind', row.is_bind === 1 ? 'success' : 'error']">{{ row.is_bind === 1 ? '已' : '未' }}绑定</span>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
};
</script>
<style lang="less" scoped>
.bind {
	display: flex;
	align-items: center;

	&::before {
		content: '';
		width: 6px;
		height: 6px;
		border-radius: 50%;
		margin-right: 6px;
	}
	&.success::before {
		background-color: @color-success;
	}

	&.error::before {
		background-color: @color-danger;
	}
}
</style>
